<template>
  <div class="inquire" v-cloak>
    <div class="sdw-bg">
      <app-header></app-header>
      <div class="sdw-banner">
        <div class="sdw-title-box">
          <p class="sdw-title">{{ $t('xdata.Nav_qqxxtxjspt') }}</p>
        </div>
      </div>
    </div>
    <!-- <p class="sdw-sub animated flipInX">随着企业规模的扩大，员工越来越多，相应的IT设备管理也越来越繁琐， 需要投入越来越多的成本和资金精力。专业外包服务将考虑您的IT整体环境和业务需求， 不仅可以完成日常维护、故障检测和维修等消防工作，还可以帮助您分析和解决故障 信息技术运行管理中存在的问题，提高信息技术应用水平，防患于未然地方。这个服务是一种技术 基于响应的支持服务模式。用户请联系服务台以获得直接的技术支持、咨询和快速的现场支持响应。 当您遇到与IT使用有关的问题，包括软硬件问题时，可以拨打技术支持热线， 帮助台工程师通过远程诊断，解决可以远程解决的问题，对于不能远程解决的问题，需要远程解决的问题 现场服务统一到那些主要负责现场服务的工程师或客户的IT工程师到客户现场解决。此过程由帮助台协调工程师.IT适用于现有的IT环境，即希望标准化管理并充分利用 利用现有IT系统实现更高价值和更低成本的优势成本主要内容是提供运维和技术支持服务 对于企业现有的IT系统。</p> -->
    <div class="sdw-content">
      <div class="sdw-content-box">
        <div class="sdw-item animated fadeInUp">
          <div>
            <p class="carousel-title">{{ $t('xdata.Sdw_zyit') }}</p>
            <p class="line"></p>
            <p class="carousel-sub">{{ $t('xdata.Sdw_zyitt1') }}</p>
            <p class="carousel-sub">{{ $t('xdata.Sdw_zyitt2') }}</p>
            <p class="carousel-sub">{{ $t('xdata.Sdw_zyitt3') }}</p>
          </div>
          <img src="@/assets/img/sdwan/102.png">
        </div>
        <div class="sdw-item animated fadeInUp" style="padding-top: 40px;">
          <img src="@/assets/img/sdwan/103.png">
          <div>
            <p class="carousel-title">{{ $t('xdata.Sdw_zyitt4') }}</p>
            <p class="line"></p>
          </div>
        </div>
        <div class="sdw-item animated fadeInUp">
          <div style="width: 400px;">
            <p class="carousel-title">{{ $t('xdata.Sdw_zyitt5') }}</p>
            <p class="line"></p>
            <p class="carousel-sub">{{ $t('xdata.Sdw_zyitt6') }}</p>
            <p class="carousel-sub">{{ $t('xdata.Sdw_zyitt7') }}</p>
            <p class="carousel-sub">{{ $t('xdata.Sdw_zyitt8') }}</p>
          </div>
          <img src="@/assets/img/sdwan/map.png" style="width: 750px;">
        </div>
        <div class="sdw-item animated fadeInUp">
          <img src="@/assets/img/sdwan/map2.png" style="width: 750px;">
          <div style="width: 400px;">
            <p class="carousel-title">{{ $t('xdata.Sdw_zyitt9') }}</p>
            <p class="line"></p>
            <p class="carousel-sub">{{ $t('xdata.Sdw_zyitt10') }}</p>
            <p class="carousel-sub">{{ $t('xdata.Sdw_zyitt11') }}</p>
          </div>
        </div>
        <div class="animated fadeInUp" style="padding-top: 40px;">
          <div>
            <p class="carousel-title">Sparkle SD-WAN-app</p>
            <p class="line"></p>
          </div>
        </div>
        <div class="sdw-item2" style="padding-top: 20px;">
          <div class="sdw-item-sol u-flex u-flex-column">
            <div class="swd-icon-box">
              <img src="@/assets/img/sdwan/105.png" class="swd-icon">
            </div>
            <span class="sdw-item-title">{{ $t('xdata.Sdw_zyitt12') }}</span>
            <div class="sdw-item-text">
              <span>▪ {{ $t('xdata.Sdw_zyitt13') }}</span>
              <span>▪ {{ $t('xdata.Sdw_zyitt14') }}</span>
            </div>
          </div>
          <img src="@/assets/img/sdwan/right.png" class="right-img">
          <div class="sdw-item-sol u-flex u-flex-column">
            <div class="swd-icon-box">
              <img src="@/assets/img/sdwan/105.png" class="swd-icon">
            </div>
            <span class="sdw-item-title">{{ $t('xdata.Sdw_zyitt15') }}</span>
            <div class="sdw-item-text">
              <span>▪ {{ $t('xdata.Sdw_zyitt16') }}</span>
              <span>▪ {{ $t('xdata.Sdw_zyitt17') }}</span>
              <span>▪ {{ $t('xdata.Sdw_zyitt18') }}</span>
            </div>
          </div>
          <img src="@/assets/img/sdwan/right.png" class="right-img">
          <div class="sdw-item-sol u-flex u-flex-column">
            <div class="swd-icon-box">
              <img src="@/assets/img/sdwan/106.png" class="swd-icon">
            </div>
            <span class="sdw-item-title">{{ $t('xdata.Sdw_zyitt19') }}</span>
            <div class="sdw-item-text">
              <span>▪ {{ $t('xdata.Sdw_zyitt20') }}</span>
              <span>▪ {{ $t('xdata.Sdw_zyitt21') }}</span>
              <span>▪ {{ $t('xdata.Sdw_zyitt22') }}</span>
            </div>
          </div>
          <img src="@/assets/img/sdwan/right.png" class="right-img">
          <div class="sdw-item-sol u-flex u-flex-column">
            <div class="swd-icon-box">
              <img src="@/assets/img/sdwan/107.png" class="swd-icon">
            </div>
            <span class="sdw-item-title">{{ $t('xdata.Sdw_zyitt23') }}</span>
            <div class="sdw-item-text">
              <span>▪ {{ $t('xdata.Sdw_zyitt24') }}</span>
              <span>▪ {{ $t('xdata.Sdw_zyitt25') }}</span>
            </div>
          </div>
        </div>
        <div class="sdw-item animated fadeInUp">
          <div>
            <p class="carousel-title">{{ $t('xdata.Sdw_zyitt26') }}</p>
            <p class="line"></p>
            <p class="carousel-sub">{{ $t('xdata.Sdw_zyitt27') }}</p>
          </div>
          <img src="@/assets/img/sdwan/vpc.png">
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>

import Header from "@/components/header";
import Footer from "@/components/footer";
import DataItem from "@/components/dataItem";
import SolItem from "@/components/solItem";

export default {
  components: {
    "app-header": Header,
    "app-footer": Footer,
    "data-item": DataItem,
    "sol-item": SolItem,
  },
  name: "service",
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {

  }
};
</script>
<style scoped>
.sdw-bg {
  width: 100%;
  background: url('../../assets/img/solution_bg2.jpg') no-repeat fixed top center / 100% auto;
}

.sdw-banner {
  height: 240px;
  background: rgba(0, 0, 0, 0.3);
}

.sdw-title-box {
  padding-top: 60px;
  width: 1200px;
  margin: 0 auto;
}

.sdw-title {
  font-size: 32px;
  color: #fff;
  margin-bottom: 20px;
  text-align: center;
}

.sdw-content {
  background: #f4f4f4;
}

.sdw-content-box {
  width: 1200px;
  margin: 0 auto;
}

.sdw-content-title {
  font-size: 28px;
  text-align: center;
  padding: 50px 0 0;
}

.sdw-content-text {
  color: #fff;
}

.sdw-content-list {
  padding-top: 50px;
}

.sdw-item2,
.sdw-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px dashed #dcdcdc;
  padding: 60px 0;
}

.sdw-item2{
  align-items: center;
}
.sdw-item:last-child {
  border: none;
}

.sdw-item img {
  display: block;
  width: 550px;
}

.sdw-item div {
  display: flex;
  flex-direction: column;
  width: 500px;
}

.carousel-title {
  font-size: 34px;
  color: #000;
  margin-bottom: 10px;
}

.line {
  width: 50px;
  height: 1px;
  border-bottom: 2px solid #009DE4;
  margin-bottom: 20px;
}

.right-img {
  width: 20px;
  height: 20px;
  padding: 6px;
  background: #a8a8a8;
  border-radius: 10px;
}

.sdw-item2 .swd-icon-box {
  width: 60px;
  height: 60px;
  background: #009DE4;
  padding: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sdw-item2 .swd-icon {
  width: 40px;
  height: auto;
}
.sdw-item-sol{
  border: 1px solid #ddd;
  width: 200px; 
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 400px;
  padding: 20px;
  border-radius: 8px;
}
.sdw-item-title{
  text-align: center;
  font-weight: bold;
  font-size: 24px;
  padding: 10px 0;
}
.sdw-item-text span{
  display: inline-block;
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  margin-bottom: 6px;
}
.carousel-sub{
  color: #333;
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/case/sdwan.vue